import { PeriodicTaskBase } from '#common/util';
import { SettingName, SettingTarget } from '#config/types';
import { FileSystemAccessMode } from './types/access-mode-synchronizer';
const DEFAULT_ACCESS_MODE_CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
export function createAccessModeSynchronizer(config, onReadOnlyDetected) {
    return new AccessModeSynchronizerImpl(config, onReadOnlyDetected);
}
class AccessModeSynchronizerImpl extends PeriodicTaskBase {
    config;
    onReadOnlyDetected;
    constructor(config, onReadOnlyDetected) {
        super('AccessModeSynchronizer', DEFAULT_ACCESS_MODE_CHECK_INTERVAL_MS);
        this.config = config;
        this.onReadOnlyDetected = onReadOnlyDetected;
    }
    onError(err) {
        this.log.error(err, 'AccessMode check failed');
    }
    async execute() {
        const settings = await this.config.get([
            { target: SettingTarget.FILE_SYSTEM, name: SettingName.FS_ACCESS_MODE },
        ]);
        const accessModeSetting = settings[0];
        if (!accessModeSetting) {
            return;
        }
        const accessMode = accessModeSetting.effective().asUint32();
        if (accessMode === FileSystemAccessMode.READ_ONLY) {
            this.onReadOnlyDetected();
        }
    }
}
